// extracted by mini-css-extract-plugin
module.exports = {"mecha":"index-mecha-1RGEC","btnDetail":"index-btnDetail-2FvKG","active":"index-active-2Jwbo"};